const startOfWeek = (date: Date, firstDay = 0) => {
  firstDay = firstDay < 0 || firstDay > 6 ? 0 : firstDay;

  let day = date.getDay();
  // Create a new date instance because we don't want to edit the original object
  let calendarStart = new Date(date);

  // Get the difference till the first day of the week plus the offset to start the week at the given day
  let diff = calendarStart.getDate() - day + ((day === 0 ? -7 : 0) + firstDay);
  calendarStart.setDate(diff);

  // In case the start date is further then the start of the month, set back with a week.
  return calendarStart > date
    ? new Date(calendarStart.setDate(calendarStart.getDate() - 7))
    : calendarStart;
};

const lastDateOfMonth = (date: Date) => {
  if (!date) { date = new Date(); }
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const buildCalendar = (startDate: Date, firstDay = 1) => {
  let calendar = [];
  let today = new Date().setHours(0, 0, 0, 0);
  let calendarDate = startOfWeek(startDate, firstDay);

  for (let weekNr = 0; weekNr < 6; weekNr++) {
    let week = [];
    if (calendarDate > lastDateOfMonth(startDate)) {
      break;
    }
    for (let day = 0; day < 7; day++) {
      week.push({
        weekDay: day,
        date: calendarDate,
        monthDay: calendarDate.getDate(),
        isToday: calendarDate.getTime() === today,
        isOtherMonth: calendarDate.getMonth() !== startDate.getMonth()
      });

      let nextDay = calendarDate.getDate() + 1;
      calendarDate = new Date(
        calendarDate.getFullYear(),
        calendarDate.getMonth(),
        nextDay,
        0,
        0,
        0
      );
    }

    calendar.push(week);
  }

  return calendar;
};
